import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import { Spinner } from 'react-bootstrap';
import FORMATTERS from 'helpers/formatters';

import { STATUSES, STATUS_CONFIG } from './utils';
import {
  Container,
  StatusItem,
  IconWrapper,
  ContentWrapper,
  Amount,
  Label,
  LoaderContainer,
  ErrorContainer,
  HeaderContainer,
  ToggleButton,
} from './styles';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa';

pluralize.addIrregularRule('cobrança', 'cobranças');

const ChargesSummary = ({ data, loading, error, onFetchChargesSummary }) => {
  const [showAll, setShowAll] = React.useState(false);

  useEffect(() => {
    onFetchChargesSummary();
  }, [onFetchChargesSummary]);

  if (loading) {
    return (
      <LoaderContainer>
        <Spinner animation="border" variant="primary" />
      </LoaderContainer>
    );
  }

  if (error) {
    return (
      <Container>
        <ErrorContainer>
          Erro ao carregar o resumo de cobranças. Tente novamente mais tarde.
        </ErrorContainer>
      </Container>
    );
  }

  const dataMap = {};
  STATUSES.forEach(statusConfig => {
    dataMap[statusConfig.id] = {
      status: statusConfig.label,
      amount: 0,
      quantity: 0,
    };
  });

  const apiStatusToIdMap = {};

  STATUSES.forEach(statusConfig => {
    statusConfig.apiStatus.forEach(apiStatus => {
      apiStatusToIdMap[apiStatus] = statusConfig.id;
    });
  });

  const filteredData = showAll ? data : data.filter(item => item.quantity > 0);

  const renderStatusItem = item => {
    const statusConfig = STATUS_CONFIG[item.variant];
    return (
      <StatusItem key={item.id} color={statusConfig.color}>
        <IconWrapper>{statusConfig.icon}</IconWrapper>
        <ContentWrapper>
          <Label>{item.status}</Label>
          <Amount>{FORMATTERS.NUMBER(item.amount || 0)}</Amount>
          {item.quantity > 0 && (
            <Label>
              {item.quantity} {pluralize('cobrança', item.quantity)}
            </Label>
          )}
        </ContentWrapper>
      </StatusItem>
    );
  };

  return (
    <>
      <HeaderContainer>
        <ToggleButton onClick={() => setShowAll(!showAll)}>
          {showAll ? 'Esconder status sem cobranças' : 'Mostrar todos os status'}
          {showAll ? <FaAngleLeft /> : <FaAngleRight />}
        </ToggleButton>
      </HeaderContainer>
      <Container showEmptyStatuses={showAll}>
        {filteredData.map(item => renderStatusItem(item))}
      </Container>
    </>
  );
};

ChargesSummary.propTypes = {
  data: PropTypes.array,
  loading: PropTypes.bool,
  error: PropTypes.object,
  onFetchChargesSummary: PropTypes.func.isRequired,
};

ChargesSummary.defaultProps = {
  data: [],
  loading: false,
  error: null,
};

export default ChargesSummary;
